import $ from 'jquery'

window.addEventListener('DOMContentLoaded', function () {
  if (document.querySelectorAll('.aps-find-a-psych').length) {
    // elements
    const $menuWrapper = $('.aps-find-a-psych__menu-wrapper')
    const $menuLeft = $('.aps-find-a-psych__menu-left')
    const $menuRight = $('.aps-find-a-psych__menu-right')
    const $selectionsBack = $('.aps-find-a-psych__selections-back')
    const $selectionsClear = $('.aps-find-a-psych__selections-clear')
    const $selectionsLimit = $('.aps-find-a-psych__selections-limit')
    const $applyFilters = $('.aps-find-a-psych__apply-filters')
    const $searchLocation = $('.aps-find-a-psych__search-location')
    const $locationContainer = $('.aps-find-a-psych__location-container')
    const $locationWrapper = $('.aps-find-a-psych__location-wrapper')
    const $locationList = $('.aps-find-a-psych__location-list')
    const $searchErrors = $('.aps-find-a-psych__search-errors')
    const $searchSubmit = $('.aps-find-a-psych__search-submit')
    const $issuesList = $('.aps-find-a-psych__issues-list')

    let selectedIssues = []

    // mobile menu for search issue, selectively shows side menus
    function showMenu(side) {
      if (side === 'left') {
        $menuRight.addClass('hidden')
        $menuLeft.removeClass('hidden')
      }
      if (side === 'right') {
        $menuLeft.addClass('hidden')
        $menuRight.removeClass('hidden')
      }
    }

    // mobile menu for search issue, selectively shows side menus
    function showTab(tab) {
      $('.is-selected').removeClass('is-selected')
      showMenu('right')
      $(`.aps-find-a-psych__tab-content[data-tab=${tab}]`).addClass(
        'is-selected'
      )
    }

    //update issues list in search bar
    function updateIssuesList() {
      if (selectedIssues.length <= 0) {
        $issuesList.html('Search by issue')
      } else {
        $issuesList.text(
          selectedIssues.reduce((prev, curr, idx) => {
            return (prev += (idx > 0 ? ', ' : '') + curr.label)
          }, '')
        )
      }
    }

    // build list of issues menu
    function buildMenuHtml(data) {
      //build list of issues from json
      let tabsListElements = '' // used to build html
      let $tabsList = $('.aps-find-a-psych__tabs-list') // will receive tabListElements
      let tabsList = data.map((tab) => tab.category)

      for (let tab of tabsList) {
        let tabCode = tab.toLowerCase().replace('/ ', ' ').replace(' ', '-')
        let tabName = tab.split('/ ')
        let formattedTabName = ''
        for (let part of tabName) {
          formattedTabName +=
            part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() + ' / '
        }
        formattedTabName = formattedTabName.slice(0, -3)
        let listElement = `
                    <li class="aps-find-a-psych__menu-item">
                    <a class="aps-find-a-psych__menu-link" title="${formattedTabName}"
                        data-tab="${tabCode}">
                        <span>
                        ${formattedTabName}
                        <span class="aps-find-a-psych__category-counter" data-tab="${tabCode}"></span>
                        </span>
                        <svg class="aps-find-a-psych__arrow" aria-hidden="true">
                        <use xlink:href="#icon-arrow"></use>
                        </svg>
                    </a>
                    </li>`
        tabsListElements += listElement
      }

      $tabsList.html(tabsListElements)
      let firstListElement = $('.aps-find-a-psych__menu-item')[0]
      $(firstListElement).addClass('is-active')

      // build tabs from json
      let tabsElements = '' // used to build html
      let $tabsWrapper = $('.aps-find-a-psych__tabs-wrapper') // will receive tabsElements

      for (let tab of data) {
        let tabName = tab.category
          .toLowerCase()
          .replace('/ ', ' ')
          .replace(' ', '-')
        let issuesList = ''
        for (let issue of tab.issues) {
          let issueElement = `
                        <div class="aps-find-a-psych__checkbox">
                            <input type="checkbox" data-label="${issue.name}"
                            data-tab="${tabName}" id="${issue.code}">
                            <label for="${issue.code}">
                            ${issue.name}
                            </label>
                        </div>`
          issuesList += issueElement
        }

        let tabElement = `
                    <div class="aps-find-a-psych__tab-content" data-tab="${tabName}">
                    <div class="aps-find-a-psych__tab-wrap">
                        <div class="aps-find-a-psych__tab">
                        <div class="aps-find-a-psych__tab-title">
                            <h3>${tab.category}</h3>
                        </div>
                        ${issuesList}
                        </div>
                    </div>
                    </div>`
        tabsElements += tabElement
      }

      $tabsWrapper.html(tabsElements)
      let firstTab = $('.aps-find-a-psych__tab-content')[0]
      $(firstTab).addClass('is-selected')
    }

    // add events listeners to component
    function addListeners() {
      const $menuLinks = $('.aps-find-a-psych__menu-link')
      const $checkboxes = $('.aps-find-a-psych__checkbox')

      // Search by issue functionality
      $issuesList.on('click', function (ev) {
        ev.stopPropagation()
        $locationWrapper.hide()
        $menuWrapper.show()
        showMenu('left')
      })

      // show side menu
      $menuLinks.on('click', function (ev) {
        ev.stopPropagation()
        $('.is-active').removeClass('is-active')
        $(ev.target)
          .closest('.aps-find-a-psych__menu-link')
          .addClass('is-active')
        showTab(ev.target.closest('.aps-find-a-psych__menu-link').dataset.tab)
      })

      // prevent click events from closing menu
      $checkboxes.on('click', function (ev) {
        ev.stopPropagation()
      })

      // manage list of issues
      $checkboxes.on('change', function (ev) {
        ev.stopPropagation()

        // box checked
        if (ev.target.checked) {
          $selectionsClear.addClass('has-selections')
          $applyFilters.addClass('has-filters')

          selectedIssues.push(ev.target.dataset)

          if (selectedIssues.length >= 3) {
            $selectionsLimit.addClass('has-limit')
          }
          if (selectedIssues.length > 3) {
            selectedIssues.pop()
            $(ev.target).prop('checked', false)
          }
        } else {
          // box unchecked
          selectedIssues = selectedIssues.filter(function (issue) {
            // check tab in case issue is duplicated
            return issue.tab != this.tab || issue.label != this.label
          }, ev.target.dataset)

          $selectionsLimit.removeClass('has-limit')

          if (selectedIssues.length <= 0) {
            $selectionsClear.removeClass('has-selections')
            $applyFilters.removeClass('has-filters')
          }
        }

        // update filters counters
        let counterStr =
          selectedIssues.length > 0 ? `( ${selectedIssues.length} )` : ''
        $('.aps-find-a-psych__filters-counter').text(counterStr)

        // update category counter
        let categoryCounter = $(
          '.aps-find-a-psych__tab-content.is-selected input:checked'
        ).length
        let activeMenuLink = $('.aps-find-a-psych__menu-link.is-active')
        activeMenuLink
          .find('.aps-find-a-psych__category-counter')
          .text(categoryCounter > 0 ? `( ${categoryCounter} )` : '')

        updateIssuesList()
      })

      // hide menu
      $selectionsBack.on('click', function (ev) {
        ev.stopPropagation()
        showMenu('left')
      })

      // clear selections
      $selectionsClear.on('click', function (ev) {
        ev.stopPropagation()
        selectedIssues = []
        $('.aps-find-a-psych__menu-right input:checked').prop('checked', false)
        $selectionsClear.removeClass('has-selections')
        $selectionsLimit.removeClass('has-limit')
        $applyFilters.removeClass('has-filters')
        $issuesList.html('Search by issue')
        $('.aps-find-a-psych__menu-link')
          .find('.aps-find-a-psych__category-counter')
          .text('')
      })

      // Search location functionality
      $searchLocation.on('keyup', function (ev) {
        const response = fetch(
          `/aps/handlers/localityjson.ashx?s=${ev.target.value}`
        )
          .then((response) => response.json())
          .then((data) => {
            $searchErrors[0].textContent = ''
            let listHtml = '<ul>'
            data.forEach((location) => {
              listHtml += `<li class="aps-find-a-psych__location-item">${location.town}, ${location.state}, ${location.postCode}</li>`
            })
            listHtml += '</ul>'
            $locationList.html(listHtml)
            $menuWrapper.hide()
            $locationWrapper.show()
            $('.aps-find-a-psych__location-item').on('click', function () {
              $searchLocation[0].value = $(this)[0].textContent
              $locationList.html(listHtml)
              $locationWrapper.hide()
              $locationContainer.addClass('has-value')
              $('.has-value').on('click', function () {
                $locationList.html('')
                $searchLocation[0].value = ''
                $locationContainer.removeClass('has-value')
              })
            })
          })
          .catch((err) => {
            ev.target.value = ''
            $searchErrors[0].textContent = 'Unable to find locations.'
          })
      })

      // close menu
      $('.aps-find-a-psych__menu-close').on('click', function () {
        $menuWrapper.hide()
      })

      // close menu
      $('body').on('click', function (ev) {
        $menuWrapper.hide()
        $locationWrapper.hide()
      })

      // validate and submit form
      $searchSubmit.on('click', function (ev) {
        ev.preventDefault()
        $searchErrors[0].textContent = '' // reset error messages

        const searchLocation = $searchLocation[0].value
        if (searchLocation == '') {
          $searchErrors[0].textContent =
            'Searching by issue must be combined with a location.'
          return
        }
        if (selectedIssues.length == 0) {
          $searchErrors[0].textContent = 'Please select at least one issue.'
          return
        }

        let uri = '/find-a-psychologist?'
        let searchLocationString = searchLocation.split(', ').join('_')
        let issuesListString = $issuesList[0].textContent.split(', ').join(',')

        uri += `location=${encodeURIComponent(
          searchLocationString
        )}&key-words=${encodeURIComponent(
          issuesListString
        )}&distance=10&drop-list-1=10&state=all-states&Page=0`
        window.location.href = uri
      })
    }

    // fetch list of issues
    const response = fetch('/aps/handlers/psychissuejson.ashx')
      .then((response) => response.json())
      .then((data) => {
        $searchErrors[0].textContent = ''
        buildMenuHtml(data)
        addListeners()
      })
      .catch((error) => {
        $searchErrors[0].textContent = 'Unable to find list of issues.'
      })
  }
})
